const getPlpCompareAttributes = masterlistWorldKey => {
    if (!masterlistWorldKey) {
        return [];
    }

    try {
        if (Sephora.configurationSettings?.recConfig?.slice) {
            //String is coming with extra quotes, removing them
            const fixedString = Sephora.configurationSettings.recConfig.slice(1, -1);
            const recommendationsConfiguration = JSON.parse(fixedString);

            if (Array.isArray(recommendationsConfiguration)) {
                const plpCompareConfig = recommendationsConfiguration.find(config => config.key === masterlistWorldKey)?.plpCompareAttrs;

                if (Array.isArray(plpCompareConfig)) {
                    return plpCompareConfig;
                }

                return [];
            }
        }

        return [];
    } catch (error) {
        Sephora.logger.verbose('Error parsing recommendation configuration:', error);

        return [];
    }
};

export default {
    getPlpCompareAttributes
};
